<script lang="ts" setup>
import Skeleton from '~/components/common/skeleton.vue'
import GameItem from '~/components/common/lobby-games/game-item.vue'
import { useLobbyGames } from '~/composables/lobby-games/use-lobby-games'
import { GAMES_HOT_LIMIT } from '~/constants'

const GAMES_HOT_GROUPS_PARAM = 'hot'

const { isLoadingGame, fetchGames, lobbyGames, gamePayload } = useLobbyGames({ instantFetch: false })
const isJsEnabled = ref(false)
const initialPayload = {
  cats: '',
  groups: GAMES_HOT_GROUPS_PARAM,
  limit: GAMES_HOT_LIMIT
}
useAsyncData('hot-games-pc', async () => {
  const result = await fetchGames(initialPayload)
  lobbyGames.value = isJsEnabled.value ? lobbyGames.value : result.games
  return result
})
onMounted(() => {
  gamePayload.value = { ...gamePayload.value, cats: '', groups: GAMES_HOT_GROUPS_PARAM, limit: GAMES_HOT_LIMIT }
  isJsEnabled.value = true
})
</script>

<template>
  <div class="games-hot">
    <h2 class="base-title__text">GAMES HOT</h2>

    <div v-if="!lobbyGames?.length && !isLoadingGame" class="no-data">
      <img
        src="/assets/images/components/lobby-games/game-nodata.png"
        fetchpriority="high"
        loading="eager"
        preload
        width="109"
        height="108"
        alt="Game no data"
      />
      <p>Danh sách game đang cập nhật</p>
    </div>

    <div v-if="isLoadingGame" class="games-hot__wrapper">
      <div v-for="index in GAMES_HOT_LIMIT" :key="index" class="games-hot__card">
        <Skeleton height="253px" />
      </div>
    </div>

    <div v-else class="games-hot__wrapper">
      <div v-for="(game, index) in lobbyGames" :key="index" class="games-hot__card">
        <GameItem :item="game" hideGameName />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.games-hot {
  .no-data {
    display: flex;
    height: inherit;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: $primary-gray;
    font-size: 18px;
    font-weight: $font-weight-semi-bold;
    line-height: normal;
    background: $white;
    margin-top: 20px;
    border-radius: 6px;
  }
  &__wrapper {
    display: flex;
    gap: 16px 24px;
    margin-top: 8px;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }
  &__card {
    cursor: pointer;
    height: auto;
    width: 100%;
    max-height: 253px;
    border-radius: 6px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
    width: 189px;
  }
}
</style>
